import { render, staticRenderFns } from "./BorrowStatistics.vue?vue&type=template&id=2b280fb2&scoped=true"
import script from "./BorrowStatistics.vue?vue&type=script&lang=js"
export * from "./BorrowStatistics.vue?vue&type=script&lang=js"
import style0 from "./BorrowStatistics.vue?vue&type=style&index=0&id=2b280fb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b280fb2",
  null
  
)

export default component.exports